<template>
  <div :class="[popperClass, 'input-number-wrap']">
    <div :class="['minus', value <= min || disabled ? 'disabled' : '']" @click="changeVal(-1)">
      -
    </div>
    <input type="number" v-model.number="val" pattern="[0-9]*" :disabled="disabled ? 'disabled' : false" @input="inputValue">
    <div :class="['plus', value >= max || disabled ? 'disabled' : '']" @click="changeVal(1)">
      +
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: Number,
    disabled: Boolean,
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 99,
    },
    popperClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    val: {
      get () {
        return this.value
      },
      set () {},
    },
  },
  methods: {
    inputValue (event) {
      let value = event.target.value

      if (value >= this.max) value = this.max
      if (value <= this.min) value = this.min

      this.$emit('change', parseInt(value))
    },
    changeVal (step) {
      if (this.disabled) return

      let val = this.value + step

      if (val >= this.max) val = this.max
      if (val <= this.min) val = this.min

      this.$emit('change', val)
    },
  },
}
</script>

<style lang="scss" scoped>
  .input-number-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 75px;
    height: 22px;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid $color-split;

    input {
      width: 33px;
      height: 100%;
      font-size: 12px;
      line-height: 22px;
      font-weight: bold;
      color: $color-gray-1;
      text-align: center;
      background: #fff;
      user-select: auto !important;
      -webkit-user-select: auto !important;

      &[disabled] {
        cursor: not-allowed;
      }
    }

    .minus,
    .plus {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 22px;
      height: 22px;
      font-size: 8px;
      color: $color-gray-1;
      background: #f9f9f9;
      font-weight: 500;
      cursor: pointer;
      user-select: none;

      &.disabled {
        color: #D1D4DD;
        cursor: not-allowed;
      }
    }
  }
  .input-number-mini {
    border: none;
    .minus,
    .plus {
      color: #666;
      width: 30px;
      height: 30px;
      border: 2px solid #DDDDDD;
      border-radius: 8px;
    }
    input {
      flex-grow: 1;
      background: none;
    }
  }
</style>
